// extracted by mini-css-extract-plugin
export default {"container":"NoAvailabilityBox_container__CpKbM","text":"NoAvailabilityBox_text__3rPWr"};